import React from 'react';
import './Warranty.css';

function Warranty() {
  return (
    <div className='warranty-div'>

        
            <h2 className='warranty-header'>CVR Cosmetic Vehicle Repair Warranty & Satisfaction Guarantee</h2><br /><br /><br />

            <h2>Our 100% Satisfaction Guarantee</h2><br />

<p>
At CVR Cosmetic Vehicle Repair, we stand behind the quality of every repair we perform. We are committed to delivering professional craftsmanship and exceptional customer service. 
If you're not completely satisfied with the quality of your repair, it's free!
<br />
<br />
</p>

<br />
<h2>Limited Lifetime Workmanship Warranty</h2>
<p>
<br />
We provide a Limited Lifetime Warranty on all workmanship for as long as you own the vehicle. This warranty covers defects resulting from our application or repair process, including paint adhesion, peeling, blistering, or workmanship-related issues under normal use and conditions.

If a covered issue arises, we will repair the affected area at no charge. If we cannot, we will refund your money.
<br />
<br />
</p>
<br />
<h2>Warranty Exclusions</h2>
<p>
<br />
This warranty does not cover damage or defects resulting from:
Accidents, collisions, or vandalism after the repair.<br />
Normal wear and tear, rock chips, scratches, or environmental damage.<br />
Improper care, abuse, or neglect.<br />
Rust, corrosion, or pre-existing damage outside the repaired area.<br />
Repairs or modifications performed by another shop or individual.<br />
Acts of nature, including hail, flooding, or severe weather.<br />
<br />
<br />
</p>
<h2>Our Promise</h2>
<p>
<br />
As a locally owned mobile business, our reputation means everything. 
We treat every vehicle as if it were our own and use professional-grade materials and proven repair techniques to provide long-lasting results. 
If you ever have a concern about your repair, simply contact us and we'll inspect it promptly and work with you to ensure your satisfaction.
        </p>
    </div>
  )
}

export default Warranty